import { type FeatureModule } from '@store/features/types';

export const jotdocsFeature: FeatureModule = {
  id: 'jotdocs',
  name: 'JotDocs',
  dependencies: [],
  reducers: {},
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};

